class SplitTextWithImage extends HTMLElement {
  constructor() {
    super();
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.section = this.closest('.section-split-text-animated') || this.parentElement;
    this.square = this.querySelector('.split-text-with-image__square');
    this.media = this.querySelector('.split-text-with-image__media');

    if (!this.section || !this.square || !this.media) return;

    this.isMobile = window.innerWidth < 768;
    this.isFullscreen = false;
    this.isAnimating = false;

    if (this.isMobile) {
      this.expandMedia();
    } else {
      this.calculateSquareRect();
      this.syncMediaBounds();
      window.addEventListener('resize', this.handleResize);
    }
  }
  
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.calculateSquareRect();
    this.syncMediaBounds();
  }

  // --- Animation Methods ---
  expandMedia() {
    if (this.isFullscreen) return; // Prevent redundant calls
    this.syncMediaBounds();
    this.isAnimating = true;
    this.isFullscreen = true;
    this.media.classList.add('is-fullscreen');
    this.square.classList.add('is-collapsed');
    this.classList.add('is-expanded');
    this.waitForTransitionEnd(() => {
      this.isAnimating = false;
    });
  }

  collapseMedia() {
    if (!this.isFullscreen) return; // Prevent redundant calls
    this.syncMediaBounds();
    this.isAnimating = true;
    this.isFullscreen = false;
    this.media.classList.remove('is-fullscreen');
    this.square.classList.remove('is-collapsed');
    this.classList.remove('is-expanded');
    this.waitForTransitionEnd(() => {
      this.isAnimating = false;
    });
  }

  waitForTransitionEnd(callback) {
    const target = this.media;
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      target.removeEventListener('transitionend', onEnd);
      clearTimeout(this.transitionTimeout);
      callback();
    };

    const onEnd = (event) => {
      if (event.target !== target) return;
      finish();
    };

    target.addEventListener('transitionend', onEnd);
    this.transitionTimeout = setTimeout(finish, 500);
  }

  calculateSquareRect() {
      if (!this.square) return;

      const rect = this.square.getBoundingClientRect();
      this.cachedSquareRect = {
          width: rect.width,
          height: rect.height
      };
      
      const sectionRect = this.section.getBoundingClientRect();
      this.cachedSquareRelativePos = {
          top: rect.top - sectionRect.top,
          left: rect.left - sectionRect.left,
          width: rect.width,
          height: rect.height
      };
  }

  syncMediaBounds() {
    if (!this.section || !this.square || !this.media) return;

    let relativeRect = this.cachedSquareRelativePos;
    if (!relativeRect) {
        this.calculateSquareRect();
        relativeRect = this.cachedSquareRelativePos;
    }

    if (!relativeRect) return;

    this.media.style.setProperty('--media-top', `${relativeRect.top}px`);
    this.media.style.setProperty('--media-left', `${relativeRect.left}px`);
    this.media.style.setProperty('--media-width', `${relativeRect.width}px`);
    this.media.style.setProperty('--media-height', `${relativeRect.height}px`);
  }
}

customElements.define('split-text-with-image', SplitTextWithImage);
